import { render } from "./BulletItem.vue?vue&type=template&id=f85353f8&scoped=true"
import script from "./BulletItem.vue?vue&type=script&lang=js"
export * from "./BulletItem.vue?vue&type=script&lang=js"

import "./BulletItem.vue?vue&type=style&index=0&id=f85353f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85353f8"]])

export default __exports__